<template>
  <div class="support" :style="{ 'min-height': clientHeight + 'px' }">
    <div class="loading" v-if="load" :style="{ 'min-height': '2007px' }"></div>
    <div class="support-header">
      <div class="header-content">
        <!-- <h2 class="title">{{ $t("m.sedNav.supportTitle") }}</h2>
         -->
        <span class="nav-title">How can we help you?</span>

        <div class="search">
          <span class="search-icon"> </span>
          <span class="support-input">
            <input type="text" class="support-ipt" placeholder="Describe your issue" v-model="searchinpt"
              @keydown.enter="search()" /></span>
        </div>
      </div>
    </div>
    <div class="support-content" v-if="!load">
      <div class="content-title">
        <span>Browse help topics</span>
      </div>
      <article class="support-main">
        <dl class="support-list" v-for="(item, index) in faqList" :key="index">
          <dt class="support-title">
            <a :href="'#' + item.ulName.replaceAll(` `, `-`)" @click="lineOpen(item.ulName)">{{ item.ulName }}
            </a>
            <span class="arrow" :class="{ active: titleActive == item.ulName ? true : false }"></span>
          </dt>
          <div class="item-overflow" :style="{ 'margin-top': -52 * item.faqListUl.length + 'px' }"
            :class="{ active: titleActive == item.ulName ? true : false }">
            <dd class="support-item" v-for="(items, index) in item.faqListUl" :key="index">
              <router-link :to="`/support/` + items.value.replaceAll(` `, `-`).replaceAll(`/`, `&`) + '/'">{{
                  items.value
              }}</router-link>
            </dd>
          </div>
        </dl>
      </article>
      <Freq></Freq>
    </div>

    <div class="support-bottom-nav">
      <div class="sbn-title">
        <div class="title">Need more help?</div>
        <div class="underline">Try these next steps:</div>
      </div>
      <div class="sbn-container">
        <div class="tabs">
          <div class="tabs-container">
            <div class="title">Join our forum/Reddit</div>
            <div class="underline">
              Ask questions, find solutions, receive update notifications, and
              share your experiences.
            </div>
            <a class="btn" href="https://forum.skybox.xyz/">Join our forum</a>
            <a class="btn" href="https://www.reddit.com/r/SKYBOXVR/">Join our Reddit</a>
          </div>
        </div>
        <div class="tabs">
          <div class="tabs-container">
            <div class="title">Contact us</div>
            <div class="underline">
              Describe your issue in details and submit a support ticket for
              further assistance.
            </div>
            <a class="btn" href="/submit-a-ticket">Submit a support ticket</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Freq from "../components/Freq.vue";
export default {
  components: { Freq },
  data() {
    return {
      clientHeight: document.documentElement.clientHeight - 104,
      searchinpt: "",
      fullWidth: document.documentElement.clientWidth,

      Frequently: "",
      load: true,
      faqList: [],
      titleActive: "",
    };
  },
  watch: {

  },
  created() {
    this.load = true;
    this.getFaqList();

    //监听窗口大小变化
    zE("webWidget", "show"); //进到页面就启动组件
    zE("webWidget", "setLocale", "en-US"); //设置语言
    window.zESettings = {
      webWidget: {
        color: { theme: "#fed65d" },
        offset: { horizontal: "25px", vertical: "25px" },
        contactForm: {
          attachments: true,
          ticketForms: [
            {
              id: 1500003094061,
              title: false,
              subject: false,
              fields: [
                {
                  id: "description",
                  hint: {
                    "en-US":
                      "For bug report, describe what went wrong and how you encountered the problem. For feature request, describe what you would like SKYBOX to support and why.",
                  },
                  prefill: { "*": " " },
                  message: " ",
                },
              ],
            },
          ],
        },
      },
    };
  },
  mounted() {
    if (this.fullWidth > 767) {
      document.querySelector(".supportLi").style.color = "#fff";
    }
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    // window.zESettings = {
    //   webWidget: {
    //     offset: { horizontal: "100px", vertical: "150px" },
    //   },
    // };
  },
  methods: {
    lineOpen(title) {
      if (title == this.titleActive) {
        this.titleActive = "";
      } else {
        this.titleActive = title;
      }
    },
    async getFaqList() {

      await this.$http({
        url: "https://64qx6jnt0a.execute-api.cn-north-1.amazonaws.com.cn/Prod/",
        method: "POST",
        data: {
          methods: "getFaqList",
          Id: "enFaqList",
        },
      })
        .then((res) => {
          this.load = false;
          this.faqList = res.data.Item.faqList;
          if (this.$route.hash.split("#")[1]) {
            this.titleActive = this.$route.hash.split("#")[1].replaceAll(`-`, ` `);
          } else {
            this.titleActive = this.faqList[0].ulName;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    search() {
      if (this.$i18n.t("m.lang") == "en") {
        if (this.searchinpt != "") {
          this.$router.push({
            path: "/search",
            query: { search: this.searchinpt },
          });
        }
      } else {
        this.$router.push({
          path: "/search-zh",
          query: { search: this.searchinpt },
        });
        0;
      }
    },
    goContent(value) {
      this.$router.push({
        path: "/content",
        query: { title: value },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/support.scss";
</style>